import axios from "axios";
import { BaseUrl, RazorPayKey, RazorPayName, RazorPaySecretKey } from "../../BaseUrl/BaseUrl";
import Mylogo from "../../assets/images/new/newLogo.jpg";


const getUserId = () => localStorage.getItem("userID");

const generateReceiptId = () => `rcpt_${new Date().getTime()}`;

const createRazorpayOrder = async (amount, receiptID) => {
    const response = await axios.post(`${BaseUrl}/razorpay/create-prod-order`, {
        amount,
        receipt: receiptID,
    });
    return response?.data?.orderId;
};

const verifyRazorpayPayment = async ({ razorpay_payment_id, razorpay_order_id, razorpay_signature, userID, orderID, amount }) => {
    try {
        const res = await axios.post(`${BaseUrl}/razorpay/verify-prod-payment`, {
            USER_ID: userID,
            ORDER_ID: orderID,
            paymentId: razorpay_payment_id,
            orderId: razorpay_order_id,
            signature: razorpay_signature,
            paymentAmount: amount,
        });
        return res.data.status === "success"
            ? { status: 1, razorpay_payment_id }
            : { status: 0 };
    } catch (error) {
        console.error("Payment verification error", error);
        throw error;
    }
};

const openRazorpayPopup = (options) => {
    const rzp = new window.Razorpay(options);
    rzp.open();
};

export const handleProceedRemainingPayment = async (Remaining_Amount) => {
    const userID = getUserId();

    if (Remaining_Amount === 0) {
        alert("All the amount already paid");
        return { status: 0 };
    }

    const receiptID = generateReceiptId();
    const orderID = await createRazorpayOrder(Remaining_Amount, receiptID);

    return new Promise((resolve, reject) => {
        const options = {
            key: RazorPayKey,
            key_secret: RazorPaySecretKey,
            amount: Remaining_Amount * 100,
            currency: "INR",
            name: RazorPayName,
            description: "Remaining Payment",
            image: Mylogo,
            order_id: orderID,
            handler: async function (response) {
                const result = await verifyRazorpayPayment({
                    ...response,
                    userID,
                    orderID,
                    amount: Remaining_Amount,
                });
                resolve(result);
            },
            modal: {
                ondismiss: () => {
                    console.warn("User closed Razorpay modal");
                    resolve({ status: 0 });
                },
            },
            theme: {
                color: "#ff416c",
            },
        };

        openRazorpayPopup(options);
    });
};



